export function isPayrollUser(user?: {
  isPayrollUser: boolean
  useNewLoginLogic: boolean
  payrollNumber?: string
}) {
  console.log("IS PAYROLL USER?")
  if (!user) {
    console.log("IS PAYROLL USER?", "NO USER")
    return false
  }
  console.log(
    "IS PAYROLL USER?",
    "new logic:",
    user.useNewLoginLogic,
    "isPayroll:",
    !!user.isPayrollUser,
    "hasPayroll:",
    !!user.payrollNumber,
  )
  return user.useNewLoginLogic ? !!user.isPayrollUser : !!user.payrollNumber
}
